import { format } from 'date-fns';

export class DateUtils {
	public static format = (value: Date, fmt = 'yyyy-MM-dd HH:mm'): string => {
		return format(value, fmt);
	};
}
